import axios from 'axios';
import {KRBS_CIRCULARS} from '@/config/constants.config';
import {AlertService} from '@/service/alert.service';
import {AppService} from '@/service/app.service';

const initCrewState = () => {
  return {
    crew: {}, //reusable
    crews: [], //$array = new array() || []
    newCrews: {},
    formCrewData: {
      search: null,
      count: 10,
      page: 1,
    },

    crewLogs: [],
    crewActivity: [],

    manningReports: [],

  };
};

const state = {
      ...initCrewState(),
    }
;

const mutations = {
  set_crew(state, payload) {
    state.crew = payload;
  },

  set_crews(state, payload) {
    state.crews = payload;
  },

  set_crew_logs(state, payload) {
    state.crewLogs = payload;
  },

  set_view_crew_logs(state, payload) {
    state.crewActivity = payload;
  },

  set_manning_reports(state, payload){
    state.manningReports = payload;
  },

  reset_form_crew_data(state) {
    state.formCrewData = {
      search: null,
      count: 10,
      page: 1,
    };
  },

};

const actions = {
  // async getCrewList({commit}, payload) {
  //   commit('set_is_loading', true);
  //   return axios.get(KRBS_CIRCULARS.MEMO_CIRCULAR_CREWS, payload).then((r) => {
  //     console.log(r.data.data.data);
  //     console.log(r.data, 'this is meta');
  //     commit('set_is_loading', false);
  //     commit('set_crews', r.data.data.data); //r.data
  //     return true;
  //   }).catch((er) => {
  //     return false;
  //   });
  // },

  async set_crew_paginated({commit}, payload) {
    commit('set_crews', []);
    commit('set_is_loading', true);
    let queryString = AppService.generateQueryString(payload);
    return axios.get(`${KRBS_CIRCULARS.CREWS}${queryString}`).then((r) => {
      // console.log(r.data.data.data);
      // console.log(r.data.data, 'this is meta');
      commit('set_is_loading', false);
      commit('set_crew_pagination', r.data.data);
      commit('set_crews', r.data.data.data); //r.data
      return true;
    }).catch((er) => {
      AlertService.responseAlertMessage('Crews paginate Error');
      return false;
    });
  },

  async getCrewLogs({commit}, params) {
    commit('set_is_loading', true);
    console.log(params);
    let queryString=AppService.generateQueryString(params);
    console.log(queryString);
    return axios.get(`${KRBS_CIRCULARS.CREW_CIRCULAR_LOGS}${queryString}`).then((r) => {
      commit('set_crew_pagination', r.data.data);
      commit('set_is_loading', false);
      commit('set_crew_logs', r.data.data.data);
      return true;
    }).catch((er) => {
      commit('set_is_loading', false);
      AlertService.responseAlertMessage(er, 'Get Crew Logs Error');
      return false;
    });
  },

  async viewCrewLogActivity({commit}, params) {
    commit('set_is_loading', true);
    return axios.get(`${KRBS_CIRCULARS.VIEW_CREW_CIRCULAR_LOGS}/${params}`).then((r) => {
      commit('set_is_loading', false);
      console.log(r.data.data);
      commit('set_view_crew_logs', r.data.data);
    }).catch((er) => {
      commit('set_is_loading', false);
      AlertService.responseAlertMessage(er, 'View Crew Logs Error');
      return false;
    });

  },

  async getManningReport({commit}, params){
    commit('set_is_loading', true);
    return axios.post(KRBS_CIRCULARS.MANNING_REPORTS, params).then((r) => {
      commit('set_is_loading', false);
      // console.log(r.data.data);
      commit('set_manning_reports', r.data.data );
    }).catch((er) => {
      commit('set_is_loading', false);
      AlertService.responseAlertMessage(er, 'Manning Reports Error');
      return false;
    });

  },

  reset_form_crew_data({commit}) {
    commit('reset_form_crew_data');
  },

};

const getters = {
  // crews: state => state.crews,
  crews: state => AppService.capitalizeProperties(state.crews),

  crew: state => state.crew,
  formCrewData: state => state.formCrewData,
  crewLogs: state => AppService.capitalizeProperties(state.crewLogs),
  crewActivity: state => state.crewActivity,

  manningReports: state => AppService.capitalizeProperties(state.manningReports),

};

/** export **/
export default {state, actions, mutations, getters};
